import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { SkeletonLoader } from "@/components/ui/SkeletonLoader";

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { isLoading, isAuthenticated } = useAuth();

  if (isLoading) return <SkeletonLoader variant="card" />;
  if (!isAuthenticated) return <Navigate to="/language" replace />;

  return <>{children}</>;
}
